import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M10.6 3.4a1.8 1.8 0 1 0-3.6 0 1.8 1.8 0 0 0 3.6 0M7.9 6.1c-.993 0-1.8.807-1.8 1.8v1.35c0 .498.402.9.9.9h.05l.313 2.798c.05.456.436.802.894.802h1.089a.901.901 0 0 0 .894-.802l.31-2.798h.05c.498 0 .9-.402.9-.9V7.9c0-.993-.807-1.8-1.8-1.8zm-2.579 6.587a.676.676 0 0 0-.242-1.328c-.911.166-1.713.4-2.306.698-.295.149-.571.329-.782.551-.21.228-.39.537-.39.917 0 .602.435 1.015.818 1.266.413.27.964.486 1.586.658 1.257.346 2.95.551 4.795.551 1.845 0 3.538-.205 4.793-.551.621-.172 1.175-.388 1.586-.658.385-.25.818-.664.818-1.266 0-.38-.18-.69-.393-.917a2.833 2.833 0 0 0-.782-.551c-.591-.298-1.393-.532-2.307-.698a.676.676 0 0 0-.241 1.328c.849.155 1.51.36 1.94.576.09.045.163.088.222.127a.158.158 0 0 1 0 .27c-.247.16-.65.332-1.21.486-1.099.307-2.668.504-4.426.504s-3.327-.197-4.435-.504c-.56-.154-.962-.326-1.21-.486a.158.158 0 0 1 0-.27c.06-.04.135-.082.223-.127.43-.216 1.09-.419 1.94-.576z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }